
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.81 14.393a2.999 2.999 0 000-4.786 1.79 1.79 0 01-.298-.284c-.264-.322-.404-.732-.276-1.127.17-.526.742-.821 1.223-.55.194.11.38.232.557.366m0 0a5.002 5.002 0 01-.557 8.341c-.48.272-1.052-.024-1.223-.549-.128-.395.012-.806.276-1.127a1.729 1.729 0 01.298-.284","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.887 17.26a5.999 5.999 0 00-.112-10.58l-.004-.002a1.277 1.277 0 01-.207-.136c-.358-.288-.545-.755-.4-1.2.17-.525.737-.818 1.237-.583a8 8 0 010 14.482c-.5.235-1.067-.058-1.238-.584-.144-.444.043-.911.4-1.2a1.29 1.29 0 01.212-.137l.112-.06zM6 15a2 2 0 011.317.495L12 19.592V4.407L7.317 8.505A2 2 0 016 9H4a1 1 0 00-1 1v4a1 1 0 001 1h2zm0 2l4.683 4.098C11.976 22.229 14 21.31 14 19.591V4.407c0-1.718-2.024-2.636-3.317-1.505L6 7H4a3 3 0 00-3 3v4a3 3 0 003 3h2z","fill":"currentColor"}})])
          )
        }
      }
    